export default "__VITE_ASSET__ISZNbgGA__"